import { mediaQueries } from '../../styles/media-queries';
import styled from '../../theme/styled-with-theme';
import { Box } from '../Box';

export const Image = styled('img')`
  border-radius: ${({ theme }) => theme.borderRadius.quickStartGuideBox};
  width: 100%;
`;

export const TextWrapper = styled(Box)`
  margin-top: -${({ theme }) => theme.spacing.xl};

  li {
    margin-left: ${({ theme }) => theme.spacing.m};

    ${mediaQueries.tablet} {
      margin-left: -${({ theme }) => theme.spacing.s};
    }
  }
`;
